export const IDLE_RULE_TYPES = {
  alarm: 'alarm',
  entity: 'entity',
};

export const IDLE_RULE_ALARM_CONDITIONS = {
  lastEvent: 'last_event',
  lastUpdate: 'last_update',
};
